import React from "react";
import GitHubCalendar from "react-github-calendar";
import ReactTooltip from "react-tooltip";
import './calendar.css'



// const selectLastHalfYear = contributions => {
//   const currentYear = new Date().getFullYear();
//   const currentMonth = new Date().getMonth();
//   const shownMonths = 24;

//   return contributions.filter(day => {
//     const date = new Date(day.date);
//     const monthOfDay = date.getMonth();

//     return (
//       date.getFullYear() === currentYear &&
//       monthOfDay > currentMonth - shownMonths &&
//       monthOfDay <= currentMonth
//     );
//   });
// };

const Calender = () => {
  
  return (

    <section className="github_sta">
      <h5> My Github Work </h5>
      <h2>My Github Calender</h2>
      <div className="calen">
        <GitHubCalendar className='clander'
          style={{ margin: "auto" }}
          username="osamakhan9"
          // transformData={selectLastHalfYear}
          blockSize={15}
          fontSize={11}
          blockMargin={10}
          blockRadius={5}
          color="#f59403"

        >
        <ReactTooltip delayShow={100} html /> 
        </GitHubCalendar>
      </div>
    </section>
  );
};

export default Calender;